import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FolderTree, Database, Layers } from 'lucide-react';
import WBSStructureManager from '../components/WBSStructureManager';
import WBSMigrationPanel from '../components/WBSMigrationPanel';
import { Button } from '../components/ui/button';

const WBSStructurePage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('structure');

  return (
    <div className="p-6 min-h-screen bg-gray-50" data-testid="wbs-structure-page">
      {/* Header */}
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </Button>
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-3">
              <FolderTree className="w-7 h-7 text-purple-600" />
              WBS Configuration
            </h1>
            <p className="text-gray-500 mt-1">
              Configure your organization's Work Breakdown Structure hierarchy levels
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-2 mb-6">
          <Button
            variant={activeTab === 'structure' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setActiveTab('structure')}
            className="flex items-center gap-2"
          >
            <Layers className="w-4 h-4" />
            Structure
          </Button>
          <Button
            variant={activeTab === 'migration' ? 'default' : 'outline'}
            size="sm"
            onClick={() => setActiveTab('migration')}
            className="flex items-center gap-2"
          >
            <Database className="w-4 h-4" />
            Migration
          </Button>
        </div>

        {/* Main Content */}
        {activeTab === 'structure' ? (
          <div className="bg-white rounded-xl border shadow-sm p-6 min-h-[600px]">
            <WBSStructureManager />
          </div>
        ) : (
          <WBSMigrationPanel />
        )}
      </div>
    </div>
  );
};

export default WBSStructurePage;
